import React, { ReactElement, useMemo, useState } from 'react';
import { Window, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { Button } from '@progress/kendo-react-buttons';
import { TextArea } from '@progress/kendo-react-inputs';
import { useNavigate, useParams } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { UserApi } from '../../../../redux/api/UserApi';
import { TicketApi } from '../../../../redux/api/TicketApi';
import { IShare } from '../../../../types/Ticket/IShare';
import { Avatar } from '@progress/kendo-react-layout';
import { IMention } from '../../../../types/User/IMention';
import { toast } from 'react-toastify';
import { PartialSpinny, SimpleSpinny, Spinny } from '../../../Nav/Spinny';
import { useCurrentUserContext } from '../../../../context/UserContext';


const Share: React.FC = () => {
    const navigate = useNavigate();
    const { ticketId } = useParams();
    const [visible, setVisible] = useState(true);
    const [copyText, setCopyText] = useState('Copy');
    //const [selectedStaff, setSelectedStaff] = useState(null);
    const [note, setNote] = useState('');
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    //const [confirmation, setConfirmation] = useState(false);
    const { profile: userProfile } = useCurrentUserContext();
    //const assignedStaff = staff?.map(ass => { return { Full_Name: ass?.Contact_Name, ID: ass.Contact_Id } });
    let { data: staffList, isLoading: staffLoading } = UserApi.useGetMentionQuery({ text: '', companyId: null });
    const [shareTicket, { isLoading: sharingTicket }] = TicketApi.useShareTicketMutation();
    const [value, setValue] = React.useState<IMention[]>([]);
    const [filter, setFilter] = useState<FilterDescriptor>({ operator: 'contains' })
    const filteredStaff = useMemo(() => staffList?.length && filter?.value ? filterBy(staffList?.slice(), filter) : staffList, [filter, staffList]);

    const onFilter = (event: MultiSelectFilterChangeEvent) => {
        console.log('Filter', event);
        //setStaff(filterBy(staffList?.slice(), event.filter));
        setFilter(event.filter);
    }

    const handleSend = async (e) => {
        e.preventDefault();
        try {
            //create a new share item
            const item = {
                Message: note,
                Contact_Ids: value.filter(v => v.value.startsWith('c')).map(v => parseInt(v.value.replace('c', ''))),
                Team_Ids: value.filter(v => v.value.startsWith('t')).map(v => parseInt(v.value.replace('c', '')))

            } as IShare
            console.log('SENDING', item);
            shareTicket({ ticketId: parseInt(ticketId), share: item }).unwrap()
                .then(() => {
                    //setConfirmation(true);
                    //setVisible(false);

                    //nom nom toast
                    toast.success('Shared successfully');

                    //go back
                    navigate(-1);

                }).catch((error) =>
                    toast.error('Error sharing ticket: ' + JSON.stringify(error))
                )
        } catch (error) {
            console.error('Error sharing ticket:', error);
            toast.error('Error sharing ticket: ' + JSON.stringify(error));
        }

        return false;
    };


    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const onWindowClose = () => {
        navigate(-1);
    }

    const renderTag = (tagData, tag: ReactElement) => {
        var imgUrl = tagData?.data[0]?.img;
        var showIMage = tagData?.data[0].img_class != 'n';
        var customElement = <div className='flex'>
            {showIMage && <Avatar size='small' rounded='full' className='user-profile-image mr-1' >
                {imgUrl?.indexOf('/images') === 0 ? <img src={`.${imgUrl}`} alt="Profile" width="30" height="30" /> : <img src={imgUrl} alt="Profile" width="30" height="30" />}
            </Avatar>}
            <div>{tagData.text}</div>
        </div>

        return React.cloneElement(tag, tag.props, [
            (customElement) as any,
            tag.props.children
        ]);
    }
    const renderItem = (li, itemProps) => {
        var data = itemProps.dataItem;
        var showIMage = data.img_class !== 'n';
        var item = (

            <div className="k-hbox" key={1}>
                {showIMage && <Avatar size={data.img_class === 'l' ? 'medium' : 'small'} rounded='full' className='user-profile-image' >
                    {data.img?.indexOf('/images') === 0 ? <img src={`.${data.img}`} alt="Profile" width="30" height="30" /> : <img src={data?.img} alt="Profile" width="30" height="30" />}
                </Avatar>}
                <div className='ms-1'>
                    <div>{data.label}</div>
                    <small className='user-sub-title' title={data.team}>{data.team}</small>
                </div>
            </div>)

        return React.cloneElement(li, li.props, item);
    };

    const handleChange = (event: MultiSelectChangeEvent) => {
        console.log('handleChange', event.value);
        setValue(event.value);
    };

    if (!filteredStaff || !userProfile?.Features.Tagging) return <></>;

    return (
        <div>
            {visible && (
                <Window modal={true} className='cool-window' minimizeButton={() => null} title={<><SvgIcon size='large' icon={svg.shareIcon} className='mr-2' ></SvgIcon>Share {userProfile?.Phrases.CallPhrase}</>} onClose={onWindowClose} initialHeight={380} initialWidth={Math.min(600, window.innerWidth)} stage={stage} onStageChange={onStageChange} >
                    <div className='position-relative'>
                        {sharingTicket && <PartialSpinny />}
                        <form className='w-100 d-flex flex-column align-items-end' onSubmit={handleSend}>
                            <MultiSelect required onChange={handleChange} tagRender={renderTag} itemRender={renderItem} placeholder='To: Name or Team' filterable={true} popupSettings={{ className: 'z500' }} onFilterChange={onFilter} data={filteredStaff} dataItemKey="value" textField="label" loading={staffLoading} />
                            <TextArea
                                value={note}
                                onChange={(e) => setNote(e.target.value)}
                                placeholder="Type a message"
                                style={{ width: '100%', marginTop: '20px', height: '100px' }}
                            />
                            <div className="w-100 mt-3 mb-3">
                                <div className=" input-group">
                                    <label className="input-group-text">Link</label>
                                    <input type="text" className="form-control" id="ticketLinkInput" value={`${document.location.href.replace('/share', '')}`} disabled readOnly />
                                    <button className="btn btn-outline-secondary" type="button" id="copyButton" onClick={
                                        //copy to clipboard
                                        () => {
                                            const copyText = document.getElementById('ticketLinkInput') as HTMLInputElement;
                                            copyText.select();
                                            navigator.clipboard.writeText(copyText.value);
                                            setCopyText('Copied!');
                                            console.log('Copied to clipboard:', copyText.value, navigator.clipboard);
                                        }
                                    }>{copyText} <SvgIcon className='ms-2' icon={svg.copyIcon} /></button>
                                </div>
                            </div>
                            <Button svgIcon={svg.paperPlaneIcon} type='submit' className='justify-content-end p-2' style={{ marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                                Share
                            </Button>
                        </form>
                    </div>
                </Window>
            )
            }
            {/* {
                confirmation && (
                    <Window title="Confirmation" onClose={() => setConfirmation(false)} initialHeight={200} initialWidth={400}>
                        <div>
                            <p>The ticket was successfully shared.</p>
                            <Button onClick={() => {
                                setConfirmation(false);
                                navigate(-1);
                            }}>
                                OK
                            </Button>
                        </div>
                    </Window>
                )
            } */}
        </div >
    );
};

export default Share;